export default __webpack_public_path__ + "static/media/down_arrow.cf6928cd.svg";